"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusGraphDefaultAttributes = exports.PayrollStatusAttributes = exports.PayrollStatus = exports.ActionNodeType = void 0;
var ActionNodeType;
(function (ActionNodeType) {
    ActionNodeType["OUTBOUND_WEBHOOKS"] = "outbound_webhooks";
})(ActionNodeType = exports.ActionNodeType || (exports.ActionNodeType = {}));
// default SplitC status (used for default config)
// this should be used as default if no custom payroll status flow is created
var PayrollStatus;
(function (PayrollStatus) {
    PayrollStatus["PENDING_RECEIVER_APPROVAL"] = "PENDING_RECEIVER_APPROVAL";
    PayrollStatus["RECEIVER_APPROVED"] = "RECEIVER_APPROVED";
    PayrollStatus["RECEIVER_DISAPPROVED"] = "RECEIVER_DISAPPROVED";
    PayrollStatus["PAID"] = "PAID";
})(PayrollStatus = exports.PayrollStatus || (exports.PayrollStatus = {}));
exports.PayrollStatusAttributes = {
    [PayrollStatus.PENDING_RECEIVER_APPROVAL]: {
        name: 'Pendente Aprovação do Recebedor',
        is_final: false,
    },
    [PayrollStatus.RECEIVER_APPROVED]: {
        name: 'Recebedor Aprovou',
        is_final: false,
    },
    [PayrollStatus.RECEIVER_DISAPPROVED]: {
        name: 'Recebedor Reprovou',
        is_final: false,
    },
    [PayrollStatus.PAID]: {
        name: 'Pago',
        is_final: true,
    },
};
exports.statusGraphDefaultAttributes = {
    version: '1.0',
    initial_status: PayrollStatus.PENDING_RECEIVER_APPROVAL,
};
